// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__NhmLm","dark":"BaseLayout_dark__ZlP94","light":"BaseLayout_light__34R6Q"};